import React, { useState } from 'react';
import ControlPanelSuccessIcon from 'components/atoms/icons/controlPanelSuccessIcon';
import { useTranslation } from 'react-i18next';
import { ModuleType } from 'infrastructure/enums';
import useUser from 'utils/useUser';
import PatientControlButton from 'components/atoms/patentControlButton';
import CrossControlIcon from 'components/atoms/icons/crossControlIcon';
import BaseGrid from 'components/atoms/base-grid';
import ClinicalNotesLoggedModal from 'components/molecules/clinical-notes-logged-modal';
import { useAccess } from 'infrastructure/hooks/access/useAccess';

import s from './styles.module.scss';

interface IProps {
  module: ModuleType;
  patientGuid: string;
}

const ClinicalNotesControls: React.FC<IProps> = (props) => {
  const { module, patientGuid } = props;

  const { t } = useTranslation();

  const [moduleType, setModuleType] = useState(module);
  const [opened, setOpened] = useState(false);

  const { isMobileDevice } = useUser();

  const {
    isCombinedModule,
    isRpmModule,
    isCcmModule,
    isBlockCcmModule,
    isReadOnlyRole,
    isCcmActionAllowed,
    isCcmActionDisabled,
    isActiveRpmStatus,
    isEnrolledCcmStatus,
  } = useAccess({
    module,
    patientGuid,
  });

  const rpmDisable = !isActiveRpmStatus;

  const ccmDisable =
    (isCombinedModule &&
      (isBlockCcmModule || isReadOnlyRole || !isCcmActionAllowed)) ||
    isCcmActionDisabled;

  const rpmRender = isRpmModule || isCombinedModule;

  const ccmRender = isCcmModule || isCombinedModule;

  const getIcon = (active: boolean) =>
    active ? ControlPanelSuccessIcon : CrossControlIcon;

  const columns = isMobileDevice || !isCombinedModule ? 1 : 2;

  const handleOpen = (m: ModuleType) => {
    setModuleType(m);
    setOpened(true);
  };

  return (
    <>
      <BaseGrid columns={columns}>
        {rpmRender && (
          <PatientControlButton
            label={t('labels.rpmClinicalNote')}
            Icon={getIcon(isActiveRpmStatus)}
            disabled={rpmDisable}
            handleClick={() => handleOpen(ModuleType.RPM)}
          />
        )}
        {ccmRender && (
          <PatientControlButton
            label={t('labels.ccmClinicalNote')}
            Icon={getIcon(isEnrolledCcmStatus)}
            disabled={ccmDisable}
            handleClick={() => handleOpen(ModuleType.CCM)}
          />
        )}
        <div className={s.absolute}>
          <ClinicalNotesLoggedModal
            module={moduleType}
            patientGuid={patientGuid}
            open={opened}
            onClose={() => setOpened(false)}
          />
        </div>
      </BaseGrid>
    </>
  );
};

export default ClinicalNotesControls;
